import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Checkbox, Flex, Input, Form, Card } from "antd";
import axios from "axios";
import React, { useState } from "react";

const Login = () => {
  const [loginUsername, setLoginUsername] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginCountry, setLoginCountry] = useState("");
  const [cardTitle, setCardTitle] = useState("Login");
  const [error, setError] = useState(false);

  const [isRegister, setIsRegister] = useState(false);
  const [authUser, setAuthUser] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  const handleRegister = () => {
    axios
      .post("http://78.186.196.90:8091/User/Register", {
        username: loginUsername,
        password: loginPassword,
        country: loginCountry,
      })
      .then(function (response) {
        const result = {
          id: response.data.id,
          username: response.data.userName,
          role: response.data.role,
        };
        localStorage.setItem("user", JSON.stringify(result));
        window.location.href = "/";
      })
      .catch(function (error) {});
  };
  const handleLogin = () => {
    setCardTitle("Login");
    axios
      .post("http://78.186.196.90:8091/User/LoginUI", {
        username: loginUsername,
        password: loginPassword,
      })
      .then(function (response) {
        if (response.data != null) {
          const result = {
            id: response.data.id,
            username: response.data.userName,
            role: response.data.role,
          };
          localStorage.setItem("user", JSON.stringify(result));
          window.location.href = "/";
        } else {
          setError(true);
        }
      })
      .catch(function (error) {});
  };
  return (
    <div className="login-wrapper">
      <Card
        title={cardTitle}
        variant="borderless"
        className="login-card"
        style={{
          width: 300,
        }}
      >
        <Form
          name="login"
          initialValues={{
            remember: true,
          }}
          style={{
            maxWidth: 360,
          }}
        >
          <Form.Item
            name="username"
            className="formItem"
            rules={[
              {
                required: true,
                message: "Please input your Username!",
              },
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Username"
              onChange={(e) => setLoginUsername(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your Password!",
                onChange: (e) => setLoginPassword(e.target.value),
              },
            ]}
          >
            <Input
              prefix={<LockOutlined />}
              type="password"
              placeholder="Password"
              onChange={(e) => setLoginPassword(e.target.value)}
            />
          </Form.Item>
          {isRegister && (
            <Form.Item
              name="country"
              rules={[
                {
                  required: true,
                  message: "Please input your country!",
                },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Country"
                onChange={(e) => setLoginCountry(e.target.value)}
              />
            </Form.Item>
          )}
          <Form.Item>
            {!isRegister && (
              <Button block type="primary" onClick={handleLogin}>
                Sign In
              </Button>
            )}
            {isRegister && (
              <Button block type="primary" onClick={handleRegister}>
                Sign Up
              </Button>
            )}
            or{" "}
            <a
              href="#"
              onClick={() => {
                setIsRegister(true);
                setCardTitle("Register");
                setError(false);
              }}
              className="register-link"
            >
              Register now!
            </a>
          </Form.Item>
          {error && (
            <p className="error">The username or password is incorrect!</p>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default Login;
